<template>
  <div>
    <div class="d-flex flex-row flex-wrap justify-content-start mb-2">
      <!-- Botones -->
      <div class="w-100">
        <div class="d-flex">
          <Button
            :size="15"
            color="#fd7e14"
            colorText="#ffffff"
            tooltip="Filtrar contenido"
            icon="fas fa-filter"
            round
            class="mr-2"
            :width="30"
            @click.native="openModal('modal')"
            traslate
          />

          <Button
            :size="15"
            color="#dc3545"
            colorText="#ffffff"
            tooltip="Borrar contenido Filtrado"
            icon="fas fa-filter"
            round
            :width="30"
            class="mr-2"
            traslate
            @click.native="removeFilters()"
          />
        </div>
      </div>
    </div>

    <ui-modal ref="modal" title="Filtros" size="large">
      <!-- Fila 1 -->
      <div>
        <!-- Row 1 -->
        <div class="d-flex">
          <ui-select
            class="w-50 mr-3"
            has-search
            label="Puerto Destino"
            placeholder="Seleccionar"
            v-model="puertoModel"
            :keys="{ label: 'name', value: 'id' }"
            :options="psFiltroPuertos"
          />

          <ui-select
            class="w-50"
            has-search
            label="Cliente"
            placeholder="Seleccionar"
            v-model="clienteModel"
            :keys="{ label: 'name', value: 'id' }"
            :options="psFiltroClientes"
          />
        </div>

        <!-- Row 2 -->
        <div class="d-flex">
          <ui-select
            class="w-50 mr-3"
            has-search
            label="Contenedor"
            placeholder="Seleccionar"
            v-model="contenedorModel"
            :keys="{ label: 'name', value: 'id' }"
            :options="psFiltroContenedores"
          />

          <ui-select
            class="w-50"
            has-search
            label="Producto"
            placeholder="Seleccionar"
            v-model="productoModel"
            :keys="{ label: 'name', value: 'id' }"
            :options="psFiltroProductos"
          />
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-10">
          <button class="btn btn-default" @click="closeModal('modal')">
            Cerrar
          </button>
        </div>
        <div class="col-2">
          <button class="btn btn-outline-secondary" @click="clear" :disabled="!psEnabledButtons">
            Limpiar
          </button>
          <button class="btn btn-outline-danger ml-2" :disabled="!psEnabledButtons" @click="filtrar">
            Filtrar
          </button>
        </div>
      </div>
    </ui-modal>
  </div>
</template>

<script>

import UiModal from "keen-ui/src/UiModal";

import Button from "../../common/Button";
import { mapActions, mapState } from "vuex";
import { filtrarPlanificacionSemanal } from "@/constants/lineas";

export default {
  components: { Button, UiModal },
  data() {
    return {
      puertoModel: "",
      clienteModel: "",
      contenedorModel: "",
      productoModel: ""
    };
  },
  computed: {
    ...mapState("lineas", [
        "psFiltroPuertos",
        "psFiltroContenedores",
        "psFiltroProductos",
        "psFiltroClientes",
        "psEnabledButtons",
        "psDetailPort",
        "psShowDetail",
        "psIsAdmin"
      ]
    )
  },
  methods: {
    ...mapActions("lineas", [
      "actionSetPSDataTableFiltrada",
      "actionSetPSDataTableNoFiltrada",
      "actionSetPSResumeDataTableFiltrada",
      "actionSetPSResumeDataTableNoFiltrada",
      "actionSetPSEnabledButtons",
      "actionSetCurrentFiltersPlanificacionSemanal",
      "actionSetPSIsAdmin",
      "actionSetPSShowDetail",
      "actionSetFlagFiltersPlanificacionSemanal"
    ]),
    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },
    clear() {
      this.puertoModel = "";
      this.clienteModel = "";
      this.contenedorModel = "";
      this.productoModel = "";
      this.actionSetFlagFiltersPlanificacionSemanal(false);
    },
    async filtrar() {

      this.$vToastify.loader("Filtrando planificaciones semanales...");

      this.actionSetPSEnabledButtons(false);

      let filters = {
          product_id: this.productoModel.id ?? null,
          client_id: this.clienteModel.id ?? null,
          port_id: this.puertoModel.id ?? null,
          container_id: this.contenedorModel.id ?? null
        };

      this.actionSetCurrentFiltersPlanificacionSemanal(filters);
      this.actionSetPSIsAdmin(this.psIsAdmin);
      this.actionSetPSShowDetail(this.psShowDetail);
      this.actionSetPSShowDetail(this.puertoModel);
      this.actionSetPSShowDetail(this.psShowDetail);

      this.actionSetFlagFiltersPlanificacionSemanal(true);      

      let response = await filtrarPlanificacionSemanal(filters);


      // this.actionSetPSResumeDataTableFiltrada(response.data);
      if (response.code === 200) {

        if (this.psIsAdmin && response.type === 1) {

          this.actionSetPSResumeDataTableFiltrada(response.data);

          if (this.psShowDetail) {

            if (this.puertoModel !== "") {

              const results = response.data.find(x => x.data[0] === this.puertoModel.name);


              this.actionSetPSDataTableFiltrada(results !== undefined && results.data_complementaria.length >= 1 ? results.data_complementaria : []);

            } else {
              const results = response.data.find(x => x.data[0] === this.psDetailPort);


              this.actionSetPSDataTableFiltrada(results !== undefined && results.data_complementaria.length >= 1 ? results.data_complementaria : []);

            }

          }

        } else {

          this.actionSetPSDataTableFiltrada(response.data);

        }

        this.closeModal("modal");

      } else {

        this.$vToastify.error(response.message, "Se produjo un error");

      }

      this.$vToastify.stopLoader();
      this.actionSetPSEnabledButtons(true);
    },
    removeFilters() {
      if (this.psIsAdmin) {
        this.actionSetPSResumeDataTableNoFiltrada();
        this.actionSetPSDataTableNoFiltrada();
      } else {
        this.actionSetPSDataTableNoFiltrada();
      }
    }
  }

};
</script>

<style>

</style>